export default __webpack_public_path__ + "static/media/rewards-dnp.a491b815.webp";